import { useMissionsTranslation } from '../../../../ui/hooks';
import { toKebabCase } from '../../../../ui/utils/toKebabCase';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { VolunteeringHoursStatus } from './VolunteeringHoursStatus';
const shiftParticipantLabelMap = {
    shiftStartTime: 'Shift Date',
    missionName: 'Missions',
    positionName: 'Position',
    hours: 'Hours',
    status: 'Status',
};
export const TableMobileColumns = ({ row, columnValues, handleAddHours }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2, flexGrow: 1 },
        React.createElement(Typography, { variant: 'subtitle2' }, row.columns.missionName),
        columnValues
            .filter((value) => value !== 'missionName')
            .map((columnName) => {
            let component;
            const columnDataTest = `${toKebabCase(columnName)}-column`;
            if (columnName === 'status') {
                component = React.createElement(VolunteeringHoursStatus, { participation: row, onAddHours: handleAddHours });
            }
            else {
                let columnValue = row.columns[columnName];
                if (columnName === 'shiftStartTime' && typeof columnValue === 'number') {
                    const date = new Date(columnValue);
                    columnValue = `${date.getMonth()}/${date.getDay()}/${date.getFullYear()}`;
                }
                else if (columnName === 'hours' && columnValue === undefined) {
                    columnValue = t('timeTracking.missingHoursTable');
                }
                component = (React.createElement(Typography, { variant: 'body2', sx: { wordBreak: 'break-word', width: { sm: '50%' } }, "data-test": columnDataTest }, columnValue));
            }
            return (React.createElement(Box, { key: row.id + `-${columnName}`, sx: { display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 } },
                React.createElement(Typography, { variant: 'subtitle2', sx: {
                        color: (theme) => theme.palette.grey['900'],
                        width: { sm: '50%' },
                    } }, shiftParticipantLabelMap[columnName]),
                component));
        })));
};
